import React from 'react';
import { Invoice } from '@/services/types/invoice.types';
import AllocationBar from '@/components/organisms/AllocationBar';
import InputField from '@/components/atoms/InputField';
import euroIcon from '@/assets/icons/euro.svg';

export interface AllocationData {
  id: string;
  name: string;
  value: number;
  color: string;
}

interface InvoiceAllocationsDetailsProps {
  invoice: Invoice | null;
  bankAccounts: AllocationData[];
  departments: AllocationData[];
  projects: AllocationData[];
  contracts: AllocationData[];
  productsAndServices: AllocationData[];
  expenseCategories: AllocationData[];
  revenueCategories: AllocationData[];
}

const InvoiceAllocationsDetails: React.FC<InvoiceAllocationsDetailsProps> = ({
  invoice,
  bankAccounts,
  departments,
  projects,
  contracts,
  productsAndServices,
  expenseCategories,
  revenueCategories
}) => {
  console.log('bankAccounts', bankAccounts);
  console.log('departments', departments);
  console.log('projects', projects);
  console.log('contracts', contracts);
  console.log('productsAndServices', productsAndServices);
  console.log('expenseCategories', expenseCategories);
  console.log('revenueCategories', revenueCategories);

  const isAllEmpty =
    bankAccounts.length === 0 &&
    departments.length === 0 &&
    projects.length === 0 &&
    contracts.length === 0 &&
    productsAndServices.length === 0 &&
    expenseCategories.length === 0 &&
    revenueCategories.length === 0;

  if (isAllEmpty) {
    return (
      <div className="space-y-4">
        <p className="font-medium text-base text-secondary">No allocations found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Bank Account Allocation */}
      {bankAccounts.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Bank Account</p>
          <div className="space-y-4">
            <AllocationBar
              items={bankAccounts.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {bankAccounts.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 text-xs md:text-sm max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Department Accounting Center Allocation */}
      {departments.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Department Accounting Center</p>
          <div className="space-y-4">
            <AllocationBar
              items={departments.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {departments.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Products and Services Accounting Center Allocation */}
      {productsAndServices.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Products and Services Accounting Center</p>
          <div className="space-y-4">
            <AllocationBar
              items={productsAndServices.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {productsAndServices.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Project Accounting Center Allocation */}
      {projects.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Project Accounting Center</p>
          <div className="space-y-4">
            <AllocationBar
              items={projects.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {projects.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Contract Accounting Center Allocation */}
      {contracts.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Contract Accounting Center</p>
          <div className="space-y-4">
            <AllocationBar
              items={contracts.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {contracts.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Expense Category Allocation */}
      {expenseCategories.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Expense Category</p>
          <div className="space-y-4">
            <AllocationBar
              items={expenseCategories.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {expenseCategories.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Revenue Category Allocation */}
      {revenueCategories.length > 0 && (
        <div className="card space-y-4">
          <p className="font-medium text-sm md:text-base">Revenue Category</p>
          <div className="space-y-4">
            <AllocationBar
              items={revenueCategories.map((item) => ({
                value: item.value,
                label: '',
                color: item.color
              }))}
              maxAllowedTotal={invoice?.payment_amount || 0}
              height={22}
              borderRadius={12}
              isOverAllocated={false}
            />

            {revenueCategories.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="w-[9px] h-[9px] rounded-full" style={{ background: item.color }} />
                  <p className="flex-1 text-xs md:text-sm font-medium leading-[100%]">{item.name}</p>
                </div>
                <InputField
                  name={item.id}
                  placeholder="Amount"
                  value={String(item.value)}
                  size="sm"
                  type="number"
                  className="flex-1 text-xs md:text-sm max-w-[125px]"
                  icon={euroIcon}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceAllocationsDetails;
